import VendorUploadQuotationPage from '@/features/vendors/routes/VendorUploadQuotationPage/VendorUploadQuotationPage'
import React from 'react'
import RFQListPage from './RFQListPage'

export const vendorRoutes = [
  {
    breadcrumb: 'BREADCRUMB_VENDOR_QUOTATION_LIST',
    path: 'RFQs',
    element: <RFQListPage />,
    children: [],
  },
  {
    breadcrumb: 'BREADCRUMB_VENDOR_QUOTATION_UPLOAD',
    path: 'RFQs/:costBudgetId',
    element: <VendorUploadQuotationPage />,
    children: [],
  },
]

export default vendorRoutes
